import PropTypes from "prop-types";
import { Ban } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const UNAVAILABLE_MESSAGE =
  "This dataset was removed. Nothing will be reported to Meta.";

export const UnavailableDatasetMarker = () => (
  <Tooltip>
    <TooltipTrigger
      aria-label={UNAVAILABLE_MESSAGE}
      className="tw:shrink-0 tw:cursor-help tw:border-0 tw:bg-transparent tw:p-0"
    >
      <Ban className="tw:size-4 tw:text-muted-foreground" />
    </TooltipTrigger>
    <TooltipContent>{UNAVAILABLE_MESSAGE}</TooltipContent>
  </Tooltip>
);

const EventDatasetName = ({ link }) => (
  <span className="tw:flex tw:min-w-0 tw:items-center tw:gap-1.5">
    <span className="tw:min-w-0 tw:break-words">{link.name}</span>
    {link.unavailable && <UnavailableDatasetMarker />}
  </span>
);

EventDatasetName.propTypes = {
  link: PropTypes.shape({
    name: PropTypes.string,
    unavailable: PropTypes.bool,
  }).isRequired,
};

export default EventDatasetName;
